/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssistitoTraumaCreateDTO
 */
export interface AssistitoTraumaCreateDTO {
    /**
     * 
     * @type {string}
     * @memberof AssistitoTraumaCreateDTO
     */
    trauma?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoTraumaCreateDTO
     */
    posizione?: string;
    /**
     * 
     * @type {Date}
     * @memberof AssistitoTraumaCreateDTO
     */
    dataTrauma?: Date;
    /**
     * 
     * @type {string}
     * @memberof AssistitoTraumaCreateDTO
     */
    causa?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoTraumaCreateDTO
     */
    dannoProvocato?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoTraumaCreateDTO
     */
    terapia?: string;
}

/**
 * Check if a given object implements the AssistitoTraumaCreateDTO interface.
 */
export function instanceOfAssistitoTraumaCreateDTO(value: object): value is AssistitoTraumaCreateDTO {
    return true;
}

export function AssistitoTraumaCreateDTOFromJSON(json: any): AssistitoTraumaCreateDTO {
    return AssistitoTraumaCreateDTOFromJSONTyped(json, false);
}

export function AssistitoTraumaCreateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssistitoTraumaCreateDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'trauma': json['trauma'] == null ? undefined : json['trauma'],
        'posizione': json['posizione'] == null ? undefined : json['posizione'],
        'dataTrauma': json['dataTrauma'] == null ? undefined : (new Date(json['dataTrauma'])),
        'causa': json['causa'] == null ? undefined : json['causa'],
        'dannoProvocato': json['dannoProvocato'] == null ? undefined : json['dannoProvocato'],
        'terapia': json['terapia'] == null ? undefined : json['terapia'],
    };
}

export function AssistitoTraumaCreateDTOToJSON(value?: AssistitoTraumaCreateDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'trauma': value['trauma'],
        'posizione': value['posizione'],
        'dataTrauma': value['dataTrauma'] == null ? undefined : ((value['dataTrauma'] as any).toISOString()),
        'causa': value['causa'],
        'dannoProvocato': value['dannoProvocato'],
        'terapia': value['terapia'],
    };
}

